var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"rounded-0",attrs:{"title":"PRIVACY POLICY"}},[_c('b-card-text',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.privacyPolicy)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }